import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import Banner from 'components/Banner';
import React from 'react';
import DefaultForm from 'components/FormSection/Forms/DefaultForm';
import { fetchProduct, selectProductContent } from 'store/slices/ProductsSlice';
import AboutProductPageContent from './PageContent';
import { ROUTES } from 'constants/routes';

export const catalogKey = 'catalog_';

const AboutProducts = () => {
    const { slug } = useParams();
    const dispatch = useDispatch();

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchProduct({ slug }));
    }, [dispatch, slug]);

    const {
        general_information,
        general_information_image,
        general_information_title,
        // =======================
        benefits_title,
        benefits,
        benefits_preview_video,
        benefits_video,
        benefits_preview_text,
        // =======================
        title,
        title_image,
        title_button,
        // =======================
        about_tag,
        about_title,
        about_description,
        // =======================
        composition_compatibility,
        composition_compatibility_title,
        // =======================
        products_title,
        nutrition_programs_title,
        trial_results_title,
        has_related_products,
        has_nutrition_programs,
        has_trial_results,
        catalogs,
    } = useSelector(selectProductContent);

    const benefits_data =
        (benefits && benefits.length) || benefits_video
            ? {
                  main_title: benefits_title,
                  benefits,
                  video: benefits_video && {
                      benefits_preview_video,
                      benefits_preview_text,
                      benefits_video,
                  },
              }
            : null;
    const related_products = has_related_products
        ? {
              main_title: products_title,
          }
        : null;
    const nutrition_programs = has_nutrition_programs
        ? {
              main_title: nutrition_programs_title,
          }
        : null;
    const trial_results = has_trial_results
        ? {
              main_title: trial_results_title,
          }
        : null;

    const catalogs_data = catalogs?.reduce(
        (prev, catalog, index) => ({
            ...prev,
            [`${catalogKey}${index}`]: {
                main_title: catalog.title,
                data: catalog,
            },
        }),
        {},
    );

    const pageContentData = {
        general_information: { general_information, main_title: general_information_title, general_information_image },
        benefits_data,
        related_products,
        composition_compatibility: { composition_compatibility, main_title: composition_compatibility_title },
        nutrition_programs,
        trial_results,
        ...catalogs_data,
    };

    return (
        <>
            <Banner
                title={title}
                image={title_image}
                buttonText={title_button}
                buttonType="find-desktop"
                to={ROUTES.contacts + '#find'}
            />

            <section className="container">
                <div className="inner-container type-2">
                    <div className="main-text-container">
                        <LabelButton>{about_tag}</LabelButton>
                        <GradientText>
                            <span dangerouslySetInnerHTML={{ __html: about_title }} />
                        </GradientText>
                        {about_description && (
                            <div className="offset-left-4 max-width-760">
                                <GradientText size="super-small">
                                    <span dangerouslySetInnerHTML={{ __html: about_description }} />
                                </GradientText>
                            </div>
                        )}
                    </div>
                </div>
                <AboutProductPageContent pageContentData={pageContentData} />
            </section>
            <DefaultForm />
        </>
    );
};

export default AboutProducts;
